/*
 * 判断类型
 * */
export let isString = (obj) => {
  return Object.prototype.toString.call(obj) === '[object String]';
};
export let isObject = obj => {
  return Object.prototype.toString.call(obj) === '[object Object]';
};
export let isBoolean = obj => {
  return Object.prototype.toString.call(obj) === '[object Boolean]';
};
export let isNumber = obj => {
  return Object.prototype.toString.call(obj) === '[object Number]';
};
export let isFunction = obj => {
  return Object.prototype.toString.call(obj) === '[object Function]';
};
export let isArray = obj => {
  return Object.prototype.toString.call(obj) === '[object Array]';
};

export let isUndefOrEmpty = (val) => {
  return val === '' || val === undefined || val === null
};

export let isEmptyObject = (obj) => {
  return obj === '' || obj === undefined || obj === null || Object.keys(obj).length <= 0
};

export function getUniqueID() {
  let id = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    let r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
    return v.toString(16);
  });
  return id;
}

//保留两位小数的方法 四舍五入法
export let keepTwodecimalFull = (num) =>{
    var result = parseFloat(num);
    if(isNaN(result)){
        return "";
    }
    result = Math.round(num * 100) / 100;
    var s_x = result.toString();
    var pos_decimal = s_x.indexOf('.');//小数点的所索引值

    //当整数时，pos_decimal = -1 自动补0
    if(pos_decimal < 0){
        pos_decimal = s_x.length;
        s_x += '.';
    }
     while (s_x.length <= pos_decimal + 2){
        s_x += '0';
     }
     return s_x;
};


//保留两位小数的方法 不四舍五入法
export let keepTwodecimalFixed = (num) => {
  var result = parseFloat(num);
  if(isNaN(result)){
      return "";
  }

  return (parseInt(num*100)/100).toFixed(2);
};

export let isAndroid = () => {
  let u = navigator.userAgent;
  return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
};

export let isIOS = () => {
  let u = navigator.userAgent;
  return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
};

export let getUrlParam = () => {
  let name, value, str;
  try{
    str = decodeURIComponent(location.search) ;
  }catch(e){
    str = location.search;
  }
  let num = str.indexOf("?");
  str = str.substr(num + 1); //取得所有参数   stringvar.substr(start [, length ]
  let arr = str.split("&"); //各个参数放到数组里
  let param = {};
  for (let i = 0; i < arr.length; i++) {
      num = arr[i].indexOf("=");
      if (num > 0) {
          name = arr[i].substring(0, num);
          value = arr[i].substr(num + 1);
          param[name] = value;
      }
  }
  return param
}

export let getUrlParamNotDecode = () => {
  let name, value, str;
  str = location.search;
  let num = str.indexOf("?");
  str = str.substr(num + 1); //取得所有参数   stringvar.substr(start [, length ]
  let arr = str.split("&"); //各个参数放到数组里
  let param = {};
  for (let i = 0; i < arr.length; i++) {
      num = arr[i].indexOf("=");
      if (num > 0) {
          name = arr[i].substring(0, num);
          value = arr[i].substr(num + 1);
          param[name] = value;
      }
  }
  return param
}

// 节流函数
export function throttle(fn, delay = 300) {
  let timer = null;
  return function(...args) {
    if (timer) return;
    timer = setTimeout(() => {
      fn.apply(this, args);
      timer = null;
    }, delay);
  };
}

export function debounce(fn, delay, options = {}) {
  let timer = null; // 存储定时器ID
  const { immediate = false } = options; // 默认非立即执行

  // 防抖包装函数
  const debounced = function (...args) {
    // 保留原函数的this指向（适配事件回调、对象方法等场景）
    const context = this;

    // 1. 清除之前的定时器（重复触发时重置延迟）
    if (timer) clearTimeout(timer);

    // 2. 立即执行逻辑（首次触发直接执行，后续防抖）
    if (immediate) {
      // 若定时器不存在，说明是首次触发/防抖周期结束，执行函数
      const isFirstTrigger = !timer;
      if (isFirstTrigger) fn.apply(context, args);

      // 重置定时器，确保后续触发进入防抖状态
      timer = setTimeout(() => {
        timer = null; // 延迟结束后释放定时器（下次可重新立即执行）
      }, delay);
    } else {
      // 3. 延迟执行逻辑（触发后延迟delay毫秒执行）
      timer = setTimeout(() => {
        fn.apply(context, args); // 延迟结束执行函数（绑定this和参数）
        timer = null; // 执行后释放定时器
      }, delay);
    }
  };

  // 4. 取消防抖（可选：手动终止未执行的回调）
  debounced.cancel = function () {
    if (timer) {
      clearTimeout(timer);
      timer = null; // 释放定时器，避免内存泄漏
    }
  };

  return debounced;
}

// 深拷贝函数实现
export function deepClone(target, map = new WeakMap()) {
  // 基本数据类型直接返回
  if (typeof target !== 'object' || target === null) {
      return target;
  }

  // 防止循环引用
  if (map.get(target)) {
      return map.get(target);
  }

  // 处理日期对象
  if (target instanceof Date) {
      return new Date(target);
  }

  // 处理正则表达式对象
  if (target instanceof RegExp) {
      return new RegExp(target);
  }

  // 处理Map对象
  if (target instanceof Map) {
      const cloneMap = new Map();
      map.set(target, cloneMap);
      target.forEach((value, key) => {
          cloneMap.set(deepClone(key, map), deepClone(value, map));
      });
      return cloneMap;
  }

  // 处理Set对象
  if (target instanceof Set) {
      const cloneSet = new Set();
      map.set(target, cloneSet);
      target.forEach(value => {
          cloneSet.add(deepClone(value, map));
      });
      return cloneSet;
  }

  // 初始化克隆对象
  const cloneTarget = new target.constructor();
  map.set(target, cloneTarget);

  // 遍历并克隆所有属性
  for (let key in target) {
      if (target.hasOwnProperty(key)) {
          cloneTarget[key] = deepClone(target[key], map);
      }
  }

  return cloneTarget;
}

// 处理路由参数，跳转页面携带
export function setRouteQuery(routerUrl, that) {
    if(that.$route.query.redirect_url){
      routerUrl = {
          ...routerUrl,
          query: {
              ...routerUrl.query,
              redirect_url: this.$route.query.redirect_url
          }
      }
    }
    return routerUrl;
}